import router from "@/router";
import { Toast } from "vant";

export function wxNativePay(data, route, query, func, param) {
  console.log("调用微信支付");
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        onBridgeReady(data, route, query, func, param),
        false
      );
    } else if (document.attachEvent) {
      document.attachEvent(
        "WeixinJSBridgeReady",
        onBridgeReady(data, route, query, func, param)
      );
      document.attachEvent(
        "onWeixinJSBridgeReady",
        onBridgeReady(data, route, query, func, param)
      );
    }
  } else {
    onBridgeReady(data, route, query, func, param);
  }
}

function onBridgeReady(data, route, query, func, param) {
  window.WeixinJSBridge.invoke(
    "getBrandWCPayRequest",
    {
      //下面参数内容都是后台返回的
      appId: data.appId, //公众号名称，由商户传入
      timeStamp: data.timeStamp, //时间戳
      nonceStr: data.nonceStr, //随机串
      package: data.packageData, //预支付id
      signType: data.signType, //微信签名方式
      paySign: data.paySign //微信签名
    },
    function(res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        if (router.currentRoute.name == route) {
          func(param);
        } else {
          router.push({
            name: route,
            query: query
          });
        }
      } else {
        Toast.fail("支付失败，请退出后重试！");
      }
    }
  );
}
